<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.user_address"
        placeholder="用户地址"
        style="width: 220px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.order_no"
        placeholder="订单号"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-select
        v-model="listQuery.plan_id"
        placeholder="节点套餐"
        clearable
        size="small"
        class="filter-item"
        style="width: 200px"
      >
        <el-option
          v-for="plan in planOptions"
          :key="plan.id"
          :label="plan.name"
          :value="plan.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="奖励状态"
        clearable
        size="small"
        class="filter-item"
        style="width: 180px"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-input
        v-model="listQuery.tx_hash"
        placeholder="交易哈希"
        style="width: 220px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
    >
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column label="用户地址" min-width="220">
        <template slot-scope="scope">
          {{ scope.row.user?.address || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="订单号" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.order?.order_no || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="节点套餐" min-width="140">
        <template slot-scope="scope">
          {{ scope.row.order?.nft_plan?.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="金额 (USDT)" width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusMap[scope.row.status]?.type || 'info'" size="mini">
            {{ statusMap[scope.row.status]?.label || scope.row.status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="交易哈希" min-width="220">
        <template slot-scope="scope">
          <span v-if="scope.row.tx_hash">{{ scope.row.tx_hash }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="错误信息" min-width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.error_msg">{{ scope.row.error_msg }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="170" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFormat }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="170" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at | dateTimeFormat }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_address: "",
        order_no: "",
        plan_id: "",
        status: "",
        tx_hash: "",
      },
      planOptions: [],
      statusOptions: [
        { label: "待处理", value: "pending" },
        { label: "已提交", value: "submitted" },
        { label: "已完成", value: "success" },
      ],
      statusMap: {
        pending: { label: "待处理", type: "warning" },
        submitted: { label: "已提交", type: "info" },
        success: { label: "已完成", type: "success" },
      },
    };
  },
  created() {
    this.getList();
    this.fetchPlanOptions();
  },
  methods: {
    getList() {
      this.listLoading = true;
      const params = { ...this.listQuery };
      Object.keys(params).forEach((key) => {
        if (
          params[key] === "" ||
          params[key] === null ||
          params[key] === undefined
        ) {
          delete params[key];
        }
      });
      request({
        url: "/api/admin/nft-plan/rewards",
        method: "get",
        params,
      })
        .then((res) => {
          this.list = res.data?.data || [];
          this.total = res.data?.total || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    fetchPlanOptions() {
      request({
        url: "/api/admin/nft-plan/list",
        method: "get",
        params: {
          page: 1,
          limit: 100,
        },
      }).then((res) => {
        this.planOptions = res.data?.data || [];
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>
